import "./App.less";
import React from "react";
import "react-quill/dist/quill.snow.css";
import { Route, Redirect, Switch } from "react-router-dom";
import HomePage from "./components/HomePage";
import KayitFormu from "./components/KayitFormu";
import LoginPage from "./components/LoginPage";
import NotFound from "./components/NotFound";
import AdminPage from "./components/AdminPage";
import Submitted from "./components/Submitted";

function App() {
  return (
    <div className="bg-eeeeee">
      <Switch>
        <Route path="/" exact>
          <Redirect to="/home" />
        </Route>
        <Route path="/home" component={HomePage} />
        <Route path="/form" component={KayitFormu} />
        <Route path="/login" component={LoginPage} />
        <Route path="/admin" component={AdminPage} />
        <Route path="/completed" component={Submitted} />

        <Route path="/404" component={NotFound} />

        <Route>
          <Redirect to="/404" />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
